import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    OnInit,
} from '@angular/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { Router } from '@angular/router';
import { NgZone } from '@angular/core';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import {
    APP_MAIN,
    APP_WEBSITE_NAME,
    APP_PORTAL_VERIFY_URL,
} from '../environments/environment';
// import { StatusBar } from '@ionic-native/status-bar/ngx';

import { IframeListenerService } from './services/iframe-listener.service';
import { AxiosListenerService } from './services/axios-listener.service';
import { IframeNavigatePath } from './constants/iframe-constants';
import { AuthService } from './services/auth.service';

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements AfterViewInit {
    constructor(
        private router: Router,
        private zone: NgZone,
        private iframeListenerService: IframeListenerService,
        private axiosListener: AxiosListenerService,
        private authService: AuthService
    ) {
        this.iframeListenerService.subscribe();
        this.deepLink();
        this.refreshApp();
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            SplashScreen.hide();
        }, 300);
    }

    refreshApp = async () => {
        this.zone.run(async () => {
            const isNotCallbackPath =
                window.location.pathname.indexOf('/callback') === -1;
            const isNotLogoutPath =
                window.location.pathname.indexOf(
                    `/${IframeNavigatePath.LOGOUT}`
                ) === -1;
            const isNotRegisterPath =
                window.location.pathname.indexOf(
                    `/${IframeNavigatePath.REGISTER}`
                ) === -1;

            // const isNotVerifyAdminPath = !/\S+.(verify\/).([^\/]+)$/g.test(
            //     window.location.pathname
            // ); // ..../verify/....token....

            if (
                isNotCallbackPath &&
                isNotLogoutPath &&
                isNotRegisterPath //&&
                //isNotVerifyAdminPath
            ) {
                await this.authService.authWithToken();
            }
            this.axiosListener.subscribeAxios();

            setTimeout(() => {
                SplashScreen.hide();
            }, 300);
        });
        // }
    };

    deepLink() {
        App.addListener('appUrlOpen', (event: URLOpenListenerEvent) => {
            const accessUrl = event.url;
            this.zone.run(() => {
                const isAccessWithPortalVerifyUrl: boolean =
                    accessUrl.indexOf(APP_PORTAL_VERIFY_URL) !== -1;
                if (isAccessWithPortalVerifyUrl) {
                    //TODO : Open form portal and go to Page Verify admin
                    const verifyToken = accessUrl
                        .replace(APP_PORTAL_VERIFY_URL, '')
                        .split('/')
                        .pop();
                    const navigatePath = `auth/${IframeNavigatePath.VERIFY.replace(
                        ':token',
                        verifyToken
                    )}`;
                    this.router.navigate([navigatePath]);
                } else {
                    //TODO : Page Normal
                    const domain = `${APP_MAIN}/${APP_WEBSITE_NAME}`.trim();
                    const slug = accessUrl.split(domain).pop();

                    const regisInd = event.url.indexOf('/set-password/r');
                    const regisToken = event.url
                        .split('/set-password/r/')
                        .pop();
                    const forgetInd = event.url.indexOf('/set-password/f');
                    const forgetToken = event.url
                        .split('/set-password/f/')
                        .pop();

                    if (regisInd != -1) {
                        this.router.navigateByUrl(
                            '/auth/set-password/r/' + regisToken
                        );
                    } else if (forgetInd != -1) {
                        this.router.navigateByUrl(
                            '/auth/set-password/f/' + forgetToken
                        );
                    } else if (slug) {
                        this.router.navigateByUrl(slug);
                    }
                }
            });
        });
    }
}
